module.exports = __webpack_public_path__ + "images/category_lp/watch/large-arrow-line-2_28bcc97fa0e7ed63e7e90f35b11fbada.png";